import Can from '../Can'

import CommunicationLink from './UpsellingLinks/CommunicationLink'
import Groups from './UpsellingLinks/Groups'
import GiftCardLink from './UpsellingLinks/GiftCardLink'
import ReputationManagementLink from './UpsellingLinks/ReputationManagementLink'
import DigitalSignageLink from './UpsellingLinks/DigitalSignageLink'
import SocialLink from './UpsellingLinks/SocialLink'
import SurveysLink from './UpsellingLinks/SurveysLink'
import WebsiteWidgetsLink from './UpsellingLinks/WebsiteWidgetsLink'

const MarketingDropdown = () => {
  return (
    <div className="navmgr-hover-menu-marketing">
      <div className="hover-menu-arrow" />
      <div className="navmgr-hover-menu__inner">
        <Can
          on={'Navbar'}
          to={'communicate'}
          feedFlag={'communicationAvailable'}
          upsellingLink={<CommunicationLink withUpsellingRedirect />}
        >
          <CommunicationLink />
        </Can>
        <Can
          on={'Navbar'}
          to={'communicate'}
          feedFlag={'communicationAvailable'}
          upsellingLink={<SurveysLink withUpsellingRedirect />}
        >
          <SurveysLink />
        </Can>
        <Can
          on={'Navbar'}
          to={'groups'}
          feedFlag={'groupsAvailable'}
          upsellingLink={<Groups withUpsellingRedirect />}
        >
          <Groups />
        </Can>
        <Can
          on={'Navbar'}
          to={'rewards'}
          isAny
          feedFlag={['rewardsAvailable', 'loyaltyAvailable']}
          upsellingLink={<GiftCardLink withUpsellingRedirect />}
        >
          <GiftCardLink />
        </Can>
        <Can
          on={'Navbar'}
          to={'rewards'}
          feedFlag={'tvAppAvailable'}
          upsellingLink={<DigitalSignageLink withUpsellingRedirect />}
        >
          <DigitalSignageLink />
        </Can>
        <Can
          on={'Navbar'}
          to={'rewards'}
          feedFlag={'reputationAvailable'}
          upsellingLink={<ReputationManagementLink withUpsellingRedirect />}
        >
          <ReputationManagementLink />
        </Can>
        <Can on={'Navbar'} to={'rewards'} upsellingLink={<SocialLink />}>
          <SocialLink />
        </Can>
        <Can on={'Navbar'} to={'websiteWidgets'} feedFlag={'websiteWidgetsAvailable'}>
          <WebsiteWidgetsLink />
        </Can>
      </div>
    </div>
  )
}

MarketingDropdown.propTypes = {}
export default MarketingDropdown
